<script lang="ts">
  import axios, { AxiosError } from "axios";
  import { t } from "../../../../core";
  import FormErrors from "../../../elements/FormErrors.svelte";
  import Input from "../../../elements/Input.svelte";
  import { passwordCheck } from "../../auth-pages/components/password-check";

  let oldPassword: string = "";
  let newPassword: string = "";
  let confirmPassword: string = "";

  let errorMessage: string = "";
  let isLoading: boolean = false;
  let isSuccess: boolean = false;
  let isErrorShowing: boolean = false;

  function updatePasswordError() {
    const { message } = passwordCheck(newPassword, confirmPassword);
    errorMessage = message;
  }

  function submit() {
    errorMessage = "";
    isLoading = true;
    isSuccess = false;
    isErrorShowing = true;

    const { isValid, message } = passwordCheck(newPassword, confirmPassword);

    if (isValid === false) {
      errorMessage = message;
      isLoading = false;
      return;
    }

    if (oldPassword.toString().trim() === "") {
      errorMessage = t("MyProfile.ChangePassword.OldPasswordRequired");
      isLoading = false;
      return;
    }

    axios
      .post("/api/Customer/changePassword", {
        oldPassword,
        newPassword,
        confirmPassword,
      })
      .then(() => (isSuccess = true))
      .catch((err: AxiosError) => (errorMessage = err?.response?.data))
      .finally(() => (isLoading = false));
  }
</script>

<Input
  type="password"
  name="oldpassword"
  placeholder={t("General.OldPassword.Title")}
  bind:value={oldPassword}
/>

<Input
  type="password"
  name="userpassword"
  placeholder={t("General.Password.Title")}
  on:blur={updatePasswordError}
  bind:value={newPassword}
/>

<Input
  type="password"
  name="userconfirmpassword"
  placeholder={t("General.RepeatPassword.Title")}
  on:blur={updatePasswordError}
  bind:value={confirmPassword}
/>

{#if isErrorShowing && errorMessage}
  <FormErrors {errorMessage} />
{/if}

{#if isSuccess}
  <div>{t("MyProfile.ChangePassword.Success")}</div>
{/if}

<button class="btn send-email__button" on:click={submit} disabled={isLoading}>
  {t("MyProfile.ChangePassword.SubmitButton")}
</button>
